import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/reports/status/select`

const getStatusSelect = (): Promise<any> => {
  return axios.get(`${URL}`)
    .then((d: AxiosResponse<any>) => d.data)
}

export {
  getStatusSelect,
}